module.exports = __webpack_public_path__ + "img/Material_trading.bbcc3a85.png";